import React, { Component } from 'react'
import {
  Form,
  Label,
  Dropdown,
  Container,
  Segment,
  Header,
  Icon,
  Popup
} from 'semantic-ui-react'
import ImagePreview from './ImagePreview/ImagePreview'
import VideoPreview from './VideoPreview/VideoPreview'
import history from 'utils/history'
import {
  parseQueryString,
  buildQueryString,
  getFileExtension,
  getSourceUrl,
  getEventsFileFromEnv,
  getSourceFileFromEnv,
  isChaptersMode
} from 'utils/functions'
import css from './Settings.module.sass'

const envs = {
  host: process.env.MEDIA_STORE_HOST,
  bucket: process.env.MEDIA_STORE_ORIGIN_BUCKET
}

const bucketModified = process.env.MEDIA_STORE_MODIFIED_BUCKET
const publicPath = process.env.PUBLIC_URL

const ORIGIN = 'origin'
const MODIFIED = 'modified'
const EMPTY = 'empty'
const OTHER = 'other'
const mediaUrlOptions = [
  { text: 'Оригинал', value: ORIGIN },
  { text: 'Другое', value: OTHER }
]
const metaUrlOptions = [
  { text: 'Оригинал', value: ORIGIN },
  { text: 'Измененный', value: MODIFIED },
  { text: 'Пустой', value: EMPTY },
  { text: 'Другое', value: OTHER }
]

function getMediaUrl (kind, filename) {
  let mediaUrl

  switch (kind) {
    case ORIGIN:
      mediaUrl = getSourceFileFromEnv(envs)(filename)
      break
    default:
      mediaUrl = ''
  }

  return mediaUrl
}

function getMetaUrl (kind, filename) {
  let metaUrl

  switch (kind) {
    case ORIGIN:
      metaUrl = getEventsFileFromEnv(envs)(filename)
      break
    case MODIFIED:
      metaUrl = getEventsFileFromEnv({
        host: envs.host,
        bucket: bucketModified
      })(filename)
      break
    case EMPTY:
      metaUrl = `${publicPath}/empty.events.json`
      break
    default:
      metaUrl = ''
  }

  return metaUrl
}

class Settings extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      isAdvanced: false,
      mediaId: '',
      mediaUrl: '',
      metaUrl: '',
      mediaUrlKind: ORIGIN,
      metaUrlKind: isChaptersMode() ? MODIFIED : ORIGIN,
      preRollUrl: '',
      postRollUrl: '',
      thumbnailUrl: '',
      watermarkUrl: '',
      notValidWebinar: false,
      notValidMeta: false,
      notValidPreroll: false,
      notValidPostroll: false,
      notValidThumbnail: false,
      notValidWatermark: false,
      isValidating: false
    }
    this.handleFormChange = this.handleFormChange.bind(this)
    this.handleSubmitForm = this.handleSubmitForm.bind(this)
    this.onLoadButtonDisabled = this.onLoadButtonDisabled.bind(this)
  }

  handleFormChange (key, value) {
    const { mediaId, mediaUrlKind, metaUrlKind } = this.state
    let newState

    switch (key) {
      case 'mediaId':
        newState = {
          [key]: value
        }

        if (mediaUrlKind !== OTHER) {
          newState.mediaUrl = getMediaUrl(mediaUrlKind, value)
        }

        if (metaUrlKind !== OTHER) {
          newState.metaUrl = getMetaUrl(metaUrlKind, value)
        }
        break
      case 'isAdvanced':
        newState = {
          [key]: value,
          mediaUrl: getMediaUrl(ORIGIN, mediaId),
          metaUrl: getMetaUrl(ORIGIN, mediaId),
          mediaUrlKind: ORIGIN,
          metaUrlKind: ORIGIN,
          preRollUrl: '',
          notValidPreroll: false,
          postRollUrl: '',
          notValidPostroll: false,
          thumbnailUrl: '',
          notValidThumbnail: false,
          watermarkUrl: '',
          notValidWatermark: false
        }
        break
      case 'mediaUrlKind':
        newState = {
          [key]: value,
          mediaUrl: getMediaUrl(value, mediaId)
        }
        break
      case 'metaUrlKind':
        newState = {
          [key]: value,
          metaUrl: getMetaUrl(value, mediaId)
        }
        break
      default:
        newState = {[key]: value}
    }

    this.setState(newState)
  }

  async _getVideoUrl (url) {
    let sourceUrl = await getSourceUrl(url)

    sourceUrl += '#t=0,5'

    return sourceUrl
  }

  _initVideoEvents (video) {
    return new Promise((resolve, reject) => {
      video.addEventListener('loadeddata', (e) => { resolve(true) })
      video.addEventListener('error', () => { resolve(false) })
    })
  }

  async validateForm () {
    const {
      preRollUrl,
      postRollUrl,
      metaUrl,
      thumbnailUrl,
      watermarkUrl
    } = this.state
    let isValidForm = true
    const newState = {
      isValidating: false
    }

    if (metaUrl && getFileExtension(metaUrl) !== 'json') {
      isValidForm = false
      newState.notValidMeta = true
    }
    if (preRollUrl) {
      this.prerollVideo.src = await this._getVideoUrl(preRollUrl)
      const videoStatus = await this._initVideoEvents(this.prerollVideo)
      isValidForm = videoStatus
      newState.notValidPreroll = !videoStatus
    }
    if (postRollUrl) {
      this.postrollVideo.src = await this._getVideoUrl(postRollUrl)
      const videoStatus = await this._initVideoEvents(this.postrollVideo)
      isValidForm = videoStatus
      newState.notValidPostroll = !videoStatus
    }
    if (thumbnailUrl && this.thumbnailPreview && this.thumbnailPreview.hiddenImage) {
      if (this.thumbnailPreview.hiddenImage.width !== 1280 || this.thumbnailPreview.hiddenImage.height !== 720) {
        isValidForm = false
        newState.notValidThumbnail = true
      }
    }
    if (watermarkUrl && this.watermarkPreview && this.watermarkPreview.hiddenImage) {
      if (this.watermarkPreview.hiddenImage.width !== 100 || this.watermarkPreview.hiddenImage.height !== 100) {
        isValidForm = false
        newState.notValidWatermark = true
      }
    }

    if (Object.keys(newState).length) {
      this.setState(newState)
    }

    return isValidForm
  }

  async handleSubmitForm (e) {
    e.preventDefault()

    if (this.state.isValidating) return false

    this.setState({ isValidating: true })

    const status = await this.validateForm()
    if (!status) return false

    const {
      isAdvanced,
      mediaId,
      mediaUrl,
      metaUrl,
      mediaUrlKind,
      metaUrlKind,
      preRollUrl,
      postRollUrl,
      thumbnailUrl,
      watermarkUrl
    } = this.state
    const { mode } = parseQueryString()
    const newMediaUrl = !isAdvanced ? getMediaUrl(mediaUrlKind, mediaId) : mediaUrl
    const newMetaUrl = !isAdvanced ? getMetaUrl(metaUrlKind, mediaId) : metaUrl
    let newLocation = `?${buildQueryString()}&webinar_id=${mediaId}&webinar_url=${newMediaUrl}`

    if (newMetaUrl) newLocation += `&meta_url=${newMetaUrl}`
    if (preRollUrl) newLocation += `&preroll_url=${preRollUrl}`
    if (postRollUrl) newLocation += `&postroll_url=${postRollUrl}`
    if (thumbnailUrl) newLocation += `&thumbnail_url=${thumbnailUrl}`
    if (watermarkUrl) newLocation += `&watermark_url=${watermarkUrl}`
    if (mode) newLocation += `&mode=${mode}`

    history.push(newLocation)
    history.goForward()
  }

  onLoadButtonDisabled () {
    const {
      mediaId,
      mediaUrl
    } = this.state

    return !mediaId || !mediaUrl
  }

  render () {
    const {
      mediaId,
      mediaUrl,
      metaUrl,
      mediaUrlKind,
      metaUrlKind,
      isAdvanced,
      preRollUrl,
      postRollUrl,
      thumbnailUrl,
      watermarkUrl,
      notValidWebinar,
      notValidMeta,
      notValidPreroll,
      notValidPostroll,
      notValidThumbnail,
      notValidWatermark,
      isValidating
    } = this.state

    return (
      <Container className={css.settings}>
        <Header as='h4' attached='top'>
          <Icon name='options' />
          <Header.Content>Настройки медиа-редактора</Header.Content>
        </Header>
        <Segment attached>
          <Form onSubmit={this.handleSubmitForm}>
            { !isChaptersMode() &&
              <Form.Group>
                <Form.Checkbox
                  label='Включить расширенный режим'
                  slider
                  value='ms'
                  checked={isAdvanced}
                  onChange={() => this.handleFormChange('isAdvanced', !isAdvanced)}
                />
              </Form.Group>
            }
            <Form.Field>
              <Form.Input
                label='Введите id записи'
                onChange={(e) => this.handleFormChange('mediaId', e.target.value)}
                value={mediaId}
                required
              />
            </Form.Field>
            <div className={!isAdvanced ? css.hidden : null}>
              <Form.Group widths='2'>
                <Form.Field required className={css.previewField}>
                  <label>Ссылка на вебинар&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: разрешение не менее 1280х720, соотношение сторон 16:9, H.264, mp4'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    action={
                      <Dropdown
                        basic
                        button
                        floating
                        options={mediaUrlOptions}
                        value={mediaUrlKind}
                        onChange={(e, data) => this.handleFormChange('mediaUrlKind', data.value)}
                      />
                    }
                    readOnly={mediaUrlKind !== OTHER}
                    error={notValidWebinar}
                    placeholder='Поместите ссылку вебинара'
                    onChange={(e) => this.handleFormChange('mediaUrl', e.target.value)}
                    value={mediaUrl}
                  />
                  { notValidWebinar &&
                    <Label basic color='red' pointing>
                      Неподходящий медиа-файл
                    </Label>
                  }
                </Form.Field>
                <Form.Field>
                  <label>Ссылка на метафайл&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: .json'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    action={
                      <Dropdown
                        basic
                        button
                        floating
                        options={metaUrlOptions}
                        value={metaUrlKind}
                        onChange={(e, data) => this.handleFormChange('metaUrlKind', data.value)}
                      />
                    }
                    readOnly={metaUrlKind !== OTHER}
                    error={notValidMeta}
                    placeholder='Поместите ссылку мета-файла'
                    onChange={(e) => this.handleFormChange('metaUrl', e.target.value)}
                    value={metaUrl}
                  />
                  { notValidMeta &&
                    <Label basic color='red' pointing>
                      Неправильный формат мета-файла
                    </Label>
                  }
                </Form.Field>
              </Form.Group>
              <Form.Group widths='2'>
                <Form.Field className={css.previewField}>
                  <label>Ссылка на преролл&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: разрешение не менее 1280х720, соотношение сторон 16:9, H.264, mp4'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    error={notValidPreroll}
                    className={css.previewInput}
                    placeholder='Поместите ссылку преролла'
                    onChange={(e) => this.handleFormChange('preRollUrl', e.target.value)}
                    value={preRollUrl}
                  />
                  <video className={css.hidden} ref={(video) => { this.prerollVideo = video }} muted autoPlay />
                  { notValidPreroll &&
                    <Label basic color='red' pointing>
                      Неподходящий преролл
                    </Label>
                  }
                  <div className={css.preview}>
                    <VideoPreview source={preRollUrl} />
                  </div>
                </Form.Field>
                <Form.Field className={css.previewField}>
                  <label>Ссылка на постролл&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: разрешение не менее 1280х720, соотношение сторон 16:9, H.264, mp4'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    error={notValidPostroll}
                    className={css.previewInput}
                    placeholder='Поместите ссылку постролла'
                    onChange={(e) => this.handleFormChange('postRollUrl', e.target.value)}
                    value={postRollUrl}
                  />
                  <video className={css.hidden} ref={(video) => { this.postrollVideo = video }} muted autoPlay />
                  { notValidPostroll &&
                    <Label basic color='red' pointing>
                      Неподходящий постролл
                    </Label>
                  }
                  <div className={css.preview}>
                    <VideoPreview source={postRollUrl} />
                  </div>
                </Form.Field>
              </Form.Group>
              <Form.Group widths='2'>
                <Form.Field className={css.previewField}>
                  <label>Ссылка на превью видео&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: 1280х720 пикселей, png'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    error={notValidThumbnail}
                    className={css.previewInput}
                    placeholder='Поместите ссылку превью видео'
                    onChange={(e) => this.handleFormChange('thumbnailUrl', e.target.value)}
                    value={thumbnailUrl}
                  />
                  { notValidThumbnail &&
                    <Label basic color='red' pointing>
                      Неподходящее превью для видео
                    </Label>
                  }
                  <div className={css.preview}>
                    <ImagePreview
                      source={thumbnailUrl}
                      ref={(thumbnailPreview) => { this.thumbnailPreview = thumbnailPreview }}
                    />
                  </div>
                </Form.Field>
                <Form.Field className={css.previewField}>
                  <label>Ссылка на watermark&nbsp;
                    <Popup
                      trigger={<Icon circular name='info' size='small' />}
                      content='Формат файла: 100x100 пикселей, png'
                      size='mini'
                    />
                  </label>
                  <Form.Input
                    error={notValidWatermark}
                    className={css.previewInput}
                    placeholder='Поместите ссылку на watermark'
                    onChange={(e) => this.handleFormChange('watermarkUrl', e.target.value)}
                    value={watermarkUrl}
                  />
                  { notValidWatermark &&
                    <Label basic color='red' pointing>
                      Неподходящий watermark
                    </Label>
                  }
                  <div className={css.preview}>
                    <ImagePreview
                      source={watermarkUrl}
                      ref={(watermarkPreview) => { this.watermarkPreview = watermarkPreview }}
                    />
                  </div>
                </Form.Field>
              </Form.Group>
            </div>
            <Form.Field disabled={this.onLoadButtonDisabled()}>
              <Form.Button loading={isValidating} color='orange'>Загрузить</Form.Button>
            </Form.Field>
          </Form>
        </Segment>
      </Container>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js